'use strict';
App.controller('ContactMeCtrl',['$scope','ngDialog','$stateParams','toastr','ProfessionalService', '$loading',
    function ($scope,ngDialog,$stateParams,toastr,ProfessionalService, $loading) {

    var viewModel = this;
    viewModel.userMessage = '';
    viewModel.userName = $stateParams.userName;
    
    viewModel.submitContactMe = async function (e) {
        try {
            $loading.start('contactMeLink');
            const data = await ProfessionalService.contactMe($stateParams.userId, {message: viewModel.userMessage});
            dialogId = ngDialog.open({
                template: 'submitInfoPopup',
                className: 'ngdialog-theme-default documentation-dialog prn-dialog',
                closeByNavigation: true,
                showClose: false,
                scope: $scope,
                closeByDocument: false,
                closeByEscape: false
            });
        } catch (e){
            toastr.error(e.message);
        } finally {
            $loading.finish('contactMeLink');
            $scope.$apply();
        }
    }

    viewModel.closePopup = function (e) {
        viewModel.userMessage = '';
        ngDialog.closeAll();
    }

}]);
